import React from 'react'
import toJS from '../hoc/toJS.jsx'
import { connect } from 'react-redux'
import { compose } from 'redux'
import hasFilter from '../hoc/hasFilter.jsx'
import hasPerformancePerCinemaFilter from '../hoc/hasPerformancePerCinemaFilter'
import TranslationCont from '../General/TranslationCont.jsx'
import OverviewFilterAccess from './OverviewFilterAccess.jsx'
import FilterResultsListAccess from './FilterResultsListAccess.jsx'

// const mapStateToProps = (state, ownProps) => ({
// })

const OverviewAccess = ({
    overviewSubtitle, //???
    dayFilters,
    filters,
    queryStringValues,
    allItems,
    items,
    cinemaFrontPkType,
    activeCinema
}) => {
    if(_.isEmpty(allItems)) {
        return ''
    }

    return (
        <div className='overview-access'>
            <h2 className="title-xlarge access-typo"><TranslationCont id="programOverview">Programmübersicht</TranslationCont></h2>
            {overviewSubtitle && <p>{overviewSubtitle}</p>}


            <OverviewFilterAccess
                filters={filters}
                dayFilters={dayFilters}
                queryStringValues={queryStringValues}
                allItems={items}
                cinemaFrontPkType={cinemaFrontPkType}
            />

            <FilterResultsListAccess
                items={items}
                dayFilters={dayFilters}
                activeCinema={activeCinema}
            />

        </div>
    )
}

export default compose(
    connect(null, null),
    toJS()
)(hasPerformancePerCinemaFilter(hasFilter(OverviewAccess)))


// export default PageOverviewListAccess